<template>
  <div class="index">
    <NavComponent :index="0"></NavComponent>
    <SideBarComponent></SideBarComponent>
      <div class="background-swiper-container">
          <Loading v-if="LOADING"></Loading>
          <Swiper v-else class="swiper-container" :options="swiperOption" ref="backSwiper">
              <Swiper-slide  class="slid-container" v-for="(slideItem , index) in slideArray" :key="index">
                  <div :class="slideItem.link ? 'slide link-active': 'slide'" @click="tapBanner(slideItem)"   v-bind:style="{backgroundImage:'url(' + slideItem.image + ')'}">
                  </div>
              </Swiper-slide>
              <div class="swiper-pagination" slot="pagination"></div>
          </Swiper>       
           <div class="scroll-button left-scroll">
                <div class="left-arrow"></div>
            </div>
            <div class="scroll-button right-scroll">
                <div class="right-arrow"></div>
            </div> 
      </div>   
    <main>
      <!-- <div>{{$t('m.music')}}</div>
      <p>hhhh</p> -->

      <div class="aparment-bg">
        <div class="invest content-container">
          <h3 class="title">汉伦投资</h3>
          <div class="title-content"><span class="line"></span>房源所见即所得 核心地段 安心收租<span class="line"></span><span class="more-aparment" @click="goloupanList()">更多好房 <img class="row-img" :src="row_img"/></span></div>
          <Loading v-if="LOADING"></Loading>
          <div v-for="(item,index) in aparmentList" :key="index" class="house" @click="goLouPan(item.id)">
            <div v-if="index%2!=0 || bodyWidth < 1024" class="house-img" v-lazy:backgroundImage = item.image><span class="right-img"></span></div>
            <div class="house-right">
              <h3 class="house-title">{{item.title}}</h3>
              <div><img class="local" :src="map_img"/>{{item.city +' · '+ '英国'}}<img v-if="item.url" class="video" :src="video_img"/></div>
              <span class="house-marke" v-for="(mark,index) in item.method" :key="index">{{mark}}</span>
              <div><span class="font-bold">产权：  </span>{{item.duration}} </div>
              <div><span class="font-bold">竣工时间：</span>{{item.completed_time}}</div>
              <div><span class="font-bold">使用面积：</span>{{item.built_area+'㎡'}}</div>
              <div class="left-button" v-bind:class="[index == 1 ? 'left-button right-button' : 'left-button']">了解更多</div>
            </div>
            <div v-if="index%2==0 && bodyWidth > 1024" class="house-img" v-bind:style="{backgroundImage:'url(' + item.image + ')'}"><span class="left-img"></span></div>
          </div>
        </div>
      </div>

      <div class="content-container manage">
        <h3 class="title">汉伦管家公寓</h3>
        <div class="title-content"><span class="line"></span>优质房源 你异国他乡的家<span class="line"></span></div>
        <div>
          <span class="city-name" v-for="(item,index) in manageList" :key="index" v-bind:class="[item.city.id == cityName ? 'city-name name-active' : 'city-name']" @click="cityTab(item.city.id,index)">{{item.city.name}}</span>
          <span class="more-aparment manage-more" @click="goHouseList()">更多好房 <img class="row-img" :src="row_img"/></span>
        </div>
        <div class="manage-img">
          <div v-for="(item,index) in cityImg" class="item-img" :key="index" @click="goHouseDetail(item.id)" v-bind:style="{background:`url('${item.image}') no-repeat center`}" style="background-size: 19rem 12.3rem;">
            <div class="manage-bg"></div>
            <div class="img-content">
              <h3 class="img-name">{{item.houseno}}</h3>
              <div>{{item.housetype}}</div>
              <div class="img-bottom">
                <!-- <img class="img-mark" :src="mark_img"/> -->
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="content-container live">
        <h3 class="title">汉伦之声</h3>
        <div class="title-content"><span class="line"></span>网罗英国最新资讯，教你玩转英伦三岛<span class="line"></span></div>
        <div class="live-item">
          <div class="live-left" @click="goNewsDetail(firstNew.outer_url)">
            <div class="left-time">{{firstNew.date}}</div>
            <h3 class="left-title  over">{{firstNew.title}}</h3>
            <p class="warp">{{firstNew.description}}</p>
            <img class="left-img"  v-lazy="firstNew.image" />
            <!-- <div class="left-img" v-bind:style="{background:`url('${item.image}') no-repeat center`}"></div> -->
            <div class="left-button">了解更多</div>
          </div>
          <div class="live-right">
            <div class="right-list" v-for="(item,index) in liveList" :key="index" @click="goNewsDetail(item.outer_url)">
              <h3 class="left-title over"><span class="spot"></span>{{item.title}}</h3>
              <p class="content warp">{{item.description}}</p>
              <div class="time-more"><span class="right-time">{{item.date}}</span><span  class="right-line">丨</span><span>了解更多</span></div>
            </div>
          </div>
        </div>
      </div>

      <div class="activity content-container">
        <h3 class="title">汉伦很“惠”</h3>
        <div class="title-content"><span class="line"></span>投资报税，租房搬家，我们不仅很会，而且超多优惠<span class="line"></span></div>
        <div class="item-list">
          <div class="active-list" v-for="(item,index) in activeList" :key="index" v-bind:style="{ backgroundImage: 'url(' + item.image + ')' }" @click="goArticlePage(item)">
            <div class="active-content">
              <div class="active-content-item">
                <div class="active-title">{{item.title}}</div>
                <div style="font-size:0.7rem;">{{item.description}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="content-container add">
        <h3 class="title">附加服务</h3>
        <div class="title-content"><span class="line"></span>租房后的生活，放心交给我来搞定<span class="line"></span></div>
        <ul class="add-main">
          <li class="keep" @click="goDetail('maintain')">
            <div class="add-img">
              <div class="keep-img"></div>
              <div>专业维修</div>
            </div>
            <div class="add-content">英国认证维修团队，及时高效为您的优质生活保驾护航</div>
          </li>
          <li class="clean" @click="goDetail('clean')">
            <div class="add-img">
              <div class="clean-img"></div>
              <div>保洁服务</div>
            </div>
            <div class="add-content">预约制专业团队，日常保洁和深度清洁一站式解决</div>
          </li>
          <li class="car" @click="goDetail('moveHouse')">
            <div class="add-img">
              <div class="car-img"></div>
              <div>省心搬家</div>
            </div>
            <div class="add-content">工作人员守时高效，全程省心搬运，点对点贴心服务</div>
          </li>
          <li class="air" @click="goDetail('pickUp')">
            <div class="add-img">
              <div class="air-img"></div>
              <div>接送机</div>
            </div>
            <div class="add-content">预约制包车接送，异国第一站安全放心</div>
          </li>
        </ul>
      </div>
    </main>
    <FooterComponent></FooterComponent>
  </div>
</template>

<script>
// @ is an alias to /srci
// import axios from 'axios'
import {mapState} from 'vuex'
import FooterComponent  from '@components/FooterComponent'
import NavComponent  from '@components/NavComponent'
import { Swiper, SwiperSlide } from "vue-awesome-swiper"
import SideBarComponent from '@components/SideBarComponent'

import 'swiper/css/swiper.css'
import map_img from '@assets/image/icon/local.png'
import video_img from '@assets/image/icon/video.png'
import mark_img from '@assets/image/icon/mark.png'
import row_img from '@assets/image/icon/right-row.png'

export default {
  name: 'Index',
  computed:{
    ...mapState([
        'LOADING'
    ])
  },
  components: {
    Swiper,SwiperSlide,
    FooterComponent,
    NavComponent,
    SideBarComponent,
  },
  data(){
    return {
      slideArray:[],
      liveList:[],
      map_img,video_img,mark_img,
      row_img,
      bodyWidth:1920,
      activeList:[],
      cityImg:[],
      aparmentList:[],
      cityName:'',
      firstNew:{},
      manageList:[],
      swiperOption: {
        loop: true,   
        grabCursor: false,
        autoplay: {//自动播放
          delay: 6000,
          disableOnInteraction: false
        },
        navigation: {
          nextEl: '.left-scroll',
          prevEl: '.right-scroll',
          hideOnClick: true,
          disabledClass: 'my-button-disabled', 
          hiddenClass: 'my-button-hidden', 
        },
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
          progressbarOpposite: true, 
          bulletElement : 'li', 
          dynamicBullets: true,  
          dynamicMainBullets: 2, 
          hideOnClick: true, 
          clickable: true, 
        },
      }  
    }
  },
  mounted(){
    this.getBanner()
    this.getCityImg()
    this.getAparment()
    this.getNews()
    this.getPreferential()
    this.bodyWidth = window.screen.width;
    if(this.$route.query.code && !this.$store.state.TOKEN){
      this.WXlogin()
    }
  },

  methods:{
    getBanner(){
      var that = this
      this.axios.get(this.url+'/api/web/cms/banner',{}).then(function(response){
         that.slideArray = response.data.data;
      }).catch(function() {
      });
    },
    getCityImg(){
      var that = this
      this.axios.get(this.url+'/api/house/recommend',{params: {}}).then(function(response){
         that.manageList = response.data.data;
         that.cityImg = response.data.data[0].list;
         that.cityName = that.manageList[0].city.id;
         that.cityImg = response.data.data[0].list.map( item =>{
            item.image.replace(/\s/g, encodeURIComponent(' '));
            return item;
         })

      }).catch(function() {
      });
    },
    getAparment(){
      var that = this
      this.axios.get(this.url+'/api/web/loupan/recommend',{}).then(function(response){
         that.aparmentList = response.data.data.slice(0,3);
      }).catch(function() {
      });
    },
    getNews(){
      var that = this
      this.axios.get(this.url+'/api/web/cms/hanlunzhisheng',{}).then(function(response){
         that.liveList = response.data.data.slice(1);
         that.firstNew = response.data.data.slice(0,1)[0];
         console.log(that.firstNew)
      }).catch(function() {
      });
    },
    getPreferential(){
      var that = this
      this.axios.get(this.url+'/api/web/cms/hanlunhenhui',{}).then(function(response){
         that.activeList = response.data.data
      }).catch(function() {
      });
    },
    cityTab(id,index){
      this.cityName = id;
      console.log(this.manageList[index])
      this.cityImg = this.manageList[index].list;
    },
    WXlogin(){
      const that = this
      this.axios.get(this.url+'/api/user/third',{params: {platform:'wechat',code:this.$route.query.code}}).then(function(response){
         if(response.data.code == 1){
           console.log(response.data.data.thirdinfo.userinfo)
           that.$store.commit('setHeadImgUrl',response.data.data.thirdinfo.userinfo.headimgurl)
           that.$store.commit('setNickName',response.data.data.thirdinfo.userinfo.nickname)
           that.$store.commit('setToken',response.data.data.userinfo.token)
           that.$store.commit('setUserId',response.data.data.userinfo.user_id)
           console.log(that.$store.state.HEADIMGURL,that.$store.state.NICKNAME,that.$store.state.TOKEN,that.$store.state.USERID,)
           that.$message({
              message: response.data.msg,
              type: 'success'
            });
         }else{
           that.$message({
              message: response.data.msg,
              type: 'warning'
            });
         }
         
      }).catch(function() {
      });
    },
    goHouseDetail(id){
      window.open('/aparmentDetail?id='+id, '_blank')
    },
    goLouPan(id){
      window.open('/houseHosting/'+id,'_blank')
    },
    goHouseList(){
      this.$router.push('/directRent')
    },
    goloupanList(){
      this.$router.push('/houseList/1')
    },
    goDetail(name){
      this.$router.push('/'+name)
    },
    goNewsDetail(url){
      window.open(url, '_blank')
    },
    tapBanner(item) {
        if (item.link) {
          window.location.href = item.link;
        }
    },
    goArticlePage(item){
      if(item.outer_url){
        window.open(item.outer_url, '_blank')
      }else{
        window.open('/article?id='+item.id)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.background-swiper-container{
    position: relative;
}
.link-active{
  cursor: pointer;
}
.slide{
  width: 100%;
  height: 64vh;
  min-height: 26rem;
  background-repeat: no-repeat;
  background-position:center;
  background-size: cover;
}
.scroll-button {
    width: 70px;
    height: 70px;
    border-radius: 35px;
    position: absolute;
    top: 50%;
    z-index: 10;
    list-style: none;
    font-size: 24px;
    line-height: 60px;
    text-align: center;
    -webkit-transition: all .3s ease;
    transition: all .3s ease;
    cursor: pointer;
    font-weight: 700;
    border:none;
}
.left-scroll {
    left: 10%;
    .left-arrow {
        width: 100%;
        height: 100%;
        background: url('../assets/image/icon/row-right.png' ) no-repeat center;
    }
}
.right-scroll {
    right: 10%;
    .right-arrow {
        width: 100%;
        height: 100%;
        background: url('../assets/image/icon/left-row.png') no-repeat center;
    }
}
.swiper-pagination{
  position: absolute;
  z-index:10;
  bottom: 0;
  left: 50%;
  height: 1rem;
  width: 1rem;
  display: flex;
  li{
    margin-right: 20px;
  }
}
.my-bullet{
  background: #a22915;
}

.title{
  color:$color;
  font-size: 1.5rem;
  margin-top: 5rem;
  text-align: center;
}
.title-content{
  font-size: 1rem;
	letter-spacing: 1px;
  color:$font;
  line-height: 2.6rem;
  margin-bottom: 1.5rem;
  text-align: center;
}

.more-aparment{
  float: right;
  color: #a22915;
  cursor: pointer;
  font-weight: 700;
  .row-img{
    width: 0.4rem;
    height: 0.75rem;
  }
}
.manage-more{
  display: inline-block;
  margin-top:0.3rem;
}
.aparment-bg{
  background: #f5f5f5;
  padding-bottom: 1rem;
}
.house{
  width: 100%;
  background: #fff;
  display: flex;
  cursor: pointer;
  justify-content: space-between;
  margin-bottom: 1.5rem;
  border-radius: 0.5rem;
}
.house:hover{
  box-shadow: 5px 5px 5px rgba(0,0,0,.3);

}
.house-right{
  margin:2rem 2.5rem 0.4rem;
  margin-top: auto;
  font-size: 1.1rem;
  color:$font;
  line-height: 2rem;
}
.local{
  width: 1rem;
  height: 1.3rem;
  margin-right: 1rem;
}
.video{
  width: 1.8rem;
  height: 1.2rem;
  margin-left: 1rem;
}

.house-title{
  font-size: 1.5rem;
  min-height: 2.8rem;
  line-height: 2.8rem;
  color: $color;
}

.house-img{
  height: 19.6rem;
  width:39.8rem;
  position: relative;
  background-repeat: no-repeat;
  background-size: 39.8rem 19.6rem;
  border-radius: 0.5rem;
  .left-img{
    display: block;
    height: 19.6rem;
    width: 6rem;
    position: absolute;
    background: url('../assets/image/index/bg-left.png');
    background-size: 6rem 19.6rem;
    left: 0;
  }
  .right-img{
    display: block;
    height: 19.6rem;
    width: 6rem;
    background: url('../assets/image/index/bg-right.png');
    background-size: 6rem 19.6rem;
    position: absolute;
    right: 0;
  }
}
.house-marke{
  display: inline-block;
  padding:0 0.8rem;
  margin-right:0.5rem;
  border:1px solid $font;
  line-height: 1.5rem;
}
.font-bold{
  font-weight: 700;
  width: 6rem;
  display: inline-block;
}

.manage{
  text-align: center;
}
.city-name{
  display: inline-block;
  padding:0 0.5rem;
  font-size: 1.2rem;
  margin-left: 1rem;
	line-height:2rem;
	color: $font;
  margin-bottom:2rem;
  cursor: pointer;
}
.name-active{
  background-color: #0e2d57;
  color: #fff;
  border-radius: 4px;
}
.manage-img{
  min-height:15rem;
  display: flex;
  justify-content: space-around;
}
.item-img{
  width: 19rem;
  height: 12.3rem;
  position: relative;
  cursor: pointer;
}
.manage-bg{
  width: 19rem;
  height: 12.3rem;
  position: absolute;
  top:0;
  background: rgba($color: #000000, $alpha: 0.3);
}
.img-content{
  width: 100%;
  color: #fff;
  position: absolute;
  text-align: center;
  bottom: 1.5rem;
}
.img-bottom{
  margin-top: 1.5rem;
}
.img-mark{
  width: 1.5rem;
  height: 1.1rem;
  margin-right: 0.5rem;
}
.img-name{
  font-size: 1.5rem;
  margin-bottom: 1rem;
  padding-top: 1.2rem;
}

.live-item{
  font-size: 0.9rem;
  display: flex;
  color: $font;
  justify-content: space-around;
}
.left-time{
  font-size: 1.5rem;
}
.left-title{
	color: $color;
  font-size: 1.2rem;
  line-height: 2.4rem;
  margin-right: 1rem;
}
.left-button{
  width: 7.2rem;
	height: 2rem;
	background-color: #a22915;
	border-radius: 0.2rem;
  color: #fff;
  text-align: center;
  line-height: 2rem;
  margin:20px 0;
  font-weight: 700;
}
.right-button{
  background-color: $color;
}
p{
  line-height: 1.5rem;
  padding:0 1rem;
  margin-bottom: 1rem;
  border-left: solid 1px #0e2d57;
}
.content{
    border-left: none;
}
.live-left{
  width: 28.3rem;
  cursor: pointer;
  background: #f9f9f9;
  padding:1.5rem 2.5rem;
}
.left-img{
  width: auto;
  height:12rem;
}
.live-right{
  margin:0 4rem;
  cursor: pointer;
  width: 23.7rem;
}
.right-list{
  border-top: solid 2px #eeeeee;
  padding:1rem 0 2rem;
  .spot{
    width: 7px;
    height: 7px;
    display: inline-block;
    border-radius: 50%;
    background: $color;
    margin-right: 13px;
    margin-bottom:0.2rem;
  }
}
.right-time{
  font-size: 1.1rem;
}
.right-line{
  margin: 0 1rem;
}
.time-more{
  float:right;
  margin-right: 1.5rem;
}

.item-list{
  display: flex;
  justify-content: space-between;
  cursor: pointer;
}
.active-list{
  position: relative;
  width: 13.5rem;
	height: 24.1rem;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 13.5rem 24.1rem;
}
.active-content{
  position: absolute;
  width: 100%;
  height: 24.1rem;
  position: absolute;
  color: #fff;
  bottom: 0rem;
  cursor: pointer;
  font-size: 0.8rem;
  background-image: linear-gradient(0deg, 
		#081321 0%, 
		rgba(8, 19, 33, 0) 69%, 
		rgba(8, 19, 33, 0) 99%,);
  // background: rgba($color: #000000, $alpha: 0.3);
}
.active-content-item{
  position: absolute;
  left: 0.6rem;
  bottom: 1rem;
  font-size: 0.8rem;
}
.active-title{
  font-size: 1rem;
  line-height: 1.6rem;
}

.add{
  text-align: center;
  margin-bottom: 9rem;
}
.add-main{
  width: 100%;
  height: 14.1rem;
  display: flex;
  box-sizing:border-box;
  border-top:solid 1px #e6e6e6;
  border-bottom:solid 1px #e6e6e6;
  border-left:solid 1px #e6e6e6;
}
.line{
  display: inline-block;
  width: 4rem;
  height: 1px;
  background: #3a4a5b;
  margin: 0 2rem 0.25rem;
}
li{
  flex: 1;
  border-right:solid 1px #e6e6e6 ;
  color:$font;
  cursor: pointer;
}
.add-img{
  width: 100%;
  height: 8.2rem;
  background: #f6f6f6;
  font-weight: 700;
  color: $color;
  font-size: 1.4rem;
}
.keep-img{
  display: inline-block;
  width:2.25rem;
  height:2.25rem;
  margin: 1.7rem 0 1rem 0 ;
  background: url("../assets/image/icon/keep.png") no-repeat center;
  background-size: 2.25rem 2.25rem;
}
.clean-img{
  display: inline-block;
  width:2.7rem;
  height:2.7rem;
  margin: 1.7rem 0 0.55rem;
  background: url("../assets/image/icon/clean.png") no-repeat center;
  background-size: 2.7rem 2.7rem;
}
.car-img{
  display: inline-block;
  width:2.6rem;
  height: 2.1rem;
  margin: 1.7rem 0 1.11rem 0 ;
  background: url("../assets/image/icon/car.png") no-repeat center;
  background-size: 2.6rem 2.1rem;
}
.air-img{
  display: inline-block;
  width:2.1rem;
  height:2.2rem;
  margin: 1.7rem 0 1rem 0 ;
  background: url("../assets/image/icon/air.png") no-repeat center;
  background-size: 2.1rem 2.2rem;
}
.add-content{
  padding:1rem 0.7rem 0;
  font-size: 1rem;
  line-height: 1.6rem;
}
.keep:hover{
  .add-img{
    background: url("../assets/image/icon/keep-bg.jpg") no-repeat center;
    color: #fff;
    .keep-img{
      background: url("../assets/image/icon/keep1.png") no-repeat center;
    }
  }
}
.clean:hover{
  .add-img{
    background: url("../assets/image/icon/clean-bg.jpg") no-repeat center;
    color: #fff;
    .clean-img{
      background: url("../assets/image/icon/clean1.png") no-repeat center;
    }
  }
}
.air:hover{
  .add-img{
    background: url("../assets/image/icon/air-bg.jpg") no-repeat center;
    color: #fff;
    .air-img{
      background: url("../assets/image/icon/air1.png") no-repeat center;
    }
  }
}
.car:hover{
  .add-img{
    background: url("../assets/image/icon/car-bg.jpg") no-repeat center;
    color: #fff;
    .car-img{
      background: url("../assets/image/icon/car1.png") no-repeat center;
    }
  }
}
@media only screen and (max-width: 1024px){
  .slide{
    width: 100%;
    height:auto;
    min-height: 18rem;
  }
  .scroll-button{
    display: none;
  }
  .title{
     margin-top: 3rem;
  }
  .aparment-bg{
    padding: 0 3%;
  }
  .manage{
    padding: 0 3%;
  }
  .manage-bg{
    width: 100%;
  }
  .item-img{
    width: 31%;
    background-size: 100% auto !important;
  }
  .house{
    display: block;
  }
  .house-right{
    margin:0;
    padding: 1.2rem 1.2rem 0.2rem 1.2rem;
  }
  .house-img{
    width: 100%;
    .right-img{
      display: none;
    }
    .left-img{
      display: none;
    }
  }
  .line{
    width: 2rem;
    margin-right: 1rem;
    margin-left: 1rem;
  }
  .item-list{
    width: 80%;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    .active-list{
      margin-bottom: 1rem;
    }
  }
  .live-left{
    padding: 1.5rem 2.5rem 0.5rem 2.5rem;
  }
  .left-img{
    width: 100%;
    height: auto;
  }
  .live-right{
    width: 90%;
    margin: 1rem auto 0;
  }
  .right-list{
    border-bottom: 1px solid #eee;
    border-top: none;
  }
  .live{
    padding: 0 3%;
  }
  .live-left{
    width: 100%;
  }
  .left-button{
    margin: 2rem auto;
  }
  .title-content{
    margin-bottom: 2rem;
  }
  .live-item{
    display: block;
  }
  p{
    padding:0 2rem;
  }
  .add{
    padding: 0 3%;
    margin-bottom: 5rem;
  }
  .add-main{
    height: auto;
  }
}
</style>

